import { render, staticRenderFns } from "./TrialsDetails.vue?vue&type=template&id=d7df192a&"
import script from "./TrialsDetails.vue?vue&type=script&lang=js&"
export * from "./TrialsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports